import { FieldInputTypeConfig, FieldInputTypeName } from '@ekkogmbh/apisdk';
import { ListItemText, MenuItem, Popover, PopoverProps, Stack } from '@mui/material';
import React from 'react';
import { ListForm } from 'src/Common/Components/Forms/ListForm';
import RegexInput from 'src/Common/Components/Forms/RegexInput';
import { StyledFormHeader } from 'src/Common/Components/Forms/StyledFormHeader';
import { StyledSelectField } from 'src/Common/Components/Forms/StyledSelectField';

interface FieldInputTypePopoverState {
  currentConfig?: FieldInputTypeConfig;
  textInput: string;
}

interface FieldInputTypePopoverProps {
  initialConfig?: FieldInputTypeConfig;
  onChangeCallback: (typeConfig: FieldInputTypeConfig) => void;
  popoverProps: PopoverProps;
}

export class FieldInputTypePopover extends React.Component<FieldInputTypePopoverProps, FieldInputTypePopoverState> {
  public state: FieldInputTypePopoverState = {
    textInput: '',
  };

  public async componentDidMount(): Promise<void> {
    const { initialConfig } = this.props;

    this.setState({ currentConfig: initialConfig ?? { name: FieldInputTypeName.ANY } });
  }

  public onChangeType(typeName: FieldInputTypeName): void {
    const { onChangeCallback } = this.props;

    const newConfig: FieldInputTypeConfig = { name: typeName };

    switch (newConfig.name) {
      case FieldInputTypeName.DROPDOWN:
        newConfig['values'] = [];
        break;
      case FieldInputTypeName.VALIDATED:
        newConfig['regex'] = '/^.*$/';
        break;
    }

    this.setState({ textInput: '', currentConfig: newConfig }, () => onChangeCallback(newConfig));
  }

  public onChangeConfig(typeConfig: FieldInputTypeConfig): void {
    const { onChangeCallback } = this.props;

    this.setState({ currentConfig: typeConfig }, () => onChangeCallback(typeConfig));
  }

  public renderTypeUI(): React.JSX.Element {
    const { currentConfig } = this.state;

    if (!currentConfig) {
      return <></>;
    }

    switch (currentConfig.name) {
      case FieldInputTypeName.VALIDATED:
        const regex = currentConfig.regex as string;

        return (
          <>
            <StyledFormHeader label={'Regex Configuration'} />
            <RegexInput
              label={'Pattern'}
              value={regex}
              onChange={(value) => this.onChangeConfig({ ...currentConfig, regex: value })}
            />
          </>
        );

      case FieldInputTypeName.DROPDOWN:
        const values = currentConfig.values as string[];

        return (
          <>
            <StyledFormHeader label={'Selectable Values'} />
            <ListForm
              items={values}
              onChange={(items: string[]) => this.onChangeConfig({ ...currentConfig, values: items })}
            />
          </>
        );
      case FieldInputTypeName.ANY:
      default:
        return <></>;
    }
  }

  public render(): React.JSX.Element {
    const { currentConfig } = this.state;
    const { popoverProps } = this.props;

    return (
      <Popover {...popoverProps}>
        <Stack
          spacing={1}
          marginLeft={2}
          marginRight={2}
          marginTop={0}
          marginBottom={1}
          minWidth={200}
          justifyContent={'center'}
          alignItems={'stretch'}
        >
          <StyledFormHeader label={'Field Type Configuration'} />
          <StyledSelectField
            label={'Type'}
            value={currentConfig ? currentConfig.name : FieldInputTypeName.ANY}
            onChange={(e) => this.onChangeType(e.target.value as FieldInputTypeName)}
          >
            {Object.values(FieldInputTypeName).map((type, idx) => (
              <MenuItem key={`fieldType-${idx}`} value={type}>
                <ListItemText primary={type} />
              </MenuItem>
            ))}
          </StyledSelectField>
          {this.renderTypeUI()}
        </Stack>
      </Popover>
    );
  }
}
